import React, { useEffect, useState } from "react";
import CartoCosmosApp from "./CartoCosmosApp.jsx";
import SplashScreen from "../presentational/SplashScreen.jsx";
import Initialize from "../../js/FetchData.js";

/**
 * App is the parent component for all of the other components in the project.
 * It fetches and parses the data needed to initialize CartoCosmos. While fetching,
 * a loading screen is shown, then the app is set as the main component when ready.
 *
 * @component
 */
export default function App() {

  const [mainComponent, setMainComponent] = useState(() => {
    return( <SplashScreen /> );
  })

  useEffect(() => {
    (async () => {
        let astroWebMaps = await Initialize();
        setMainComponent( <CartoCosmosApp astroWebMaps={astroWebMaps} /> );
    })();
  }, [])

  return ( <> {mainComponent} </> );
}
